export default __webpack_public_path__ + "static/media/image3.6626d49b.png";